export default __webpack_public_path__ + "static/img8-9d96f7f2c20b999e10c94ae2b04ce3e3.png";